<template>
  <div
    class="chip-status-click"
    @click.prevent="onClick()"
  >
    <chip-status
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import ChipStatus from 'Support/components/chips/ChipStatus.vue';

export default {
  name: 'ChipStatusClick',
  components: {
    ChipStatus,
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="stylus">
  .chip-status-click
    cursor pointer
    .v-chip
      cursor pointer
    .v-chip--label
      .v-chip__content
        cursor pointer

</style>
